// Host url
export const HOST_URL = {
    CLIENT_URL: process.env.VUE_APP_CLIENT_HOST,
    API_URL: process.env.VUE_APP_API_HOST,
};

// Prefixed
export const PRE_FIX_ROUTE = {
    USER: '/api/auth/',
    RENTAL: '/api/rental/',
    FIXED_RENTAL: '/api/fixed-rental/',
    EXTRA_SERVICE: '/api/extra-service/',
    BILLING: '/api/billing/',
    TRANSACTION: '/api/transaction/',
    NOTIFICATIONS: '/api/notifications/',
    RATING: '/api/rating/',
    USER_HISTORY: '/api/user-history/',
    SNAPSHOT: '/api/machine-snapshot/',
    API: '/api/developer/',
    NEWS: '/api/rental-news/',
    CHAT_HISTORY: '/api/chat-history/',
}

// User
export const USER_ROUTE = {
    CHANGE_PASSWORD: 'change-password',
    PROFILE_SETTINGS_VIEW: 'profile-settings-view',
    PROFILE_SETTINGS_MODIFY: 'profile-settings-modify',
    INVOICE_BILLING_SETTINGS_VIEW: 'invoice-billing-settings-view',
    INVOICE_BILLING_SETTINGS_MODIFY: 'invoice-billing-settings-modify',
    NOTIFICATION_SETTINGS_VIEW: 'notification-settings-view',
    NOTIFICATION_SETTINGS_MODIFY: 'notification-settings-modify',
    EMAIL_SETTINGS_VIEW: 'email-settings-view',
    EMAIL_SETTINGS_MODIFY: 'email-settings-modify',

    GET_TWO_FACTOR_AUTH_INFO: 'get-enable-tfa-info',
    ENABLE_TWO_FACTOR_AUTH: 'post-enable-tfa',
    DISABLE_TWO_FACTOR_AUTH: 'post-disable-tfa',
    IS_ENABLE_TWO_FACTOR_AUTH: 'get-is-enable-tfa-info',
    PRE_LOGIN_CHECK_TWO_FACTOR_AUTH: 'get-precheck-enable-tfa-info',

    IS_PARSEC_PRIME_ACTIVED: 'parsec-prime-get-is-actived',
    PARSEC_PRIME_GET_INFO: 'parsec-prime-get-info',
    ENABLE_DISABLE_PARSEC_PRIME: 'parsec-prime-enable-disable',
    SAVE_PARSEC_PRIME_SETTINGS: 'parsec-prime-save-settings',
    LEAVE_TEAM_PARSEC_PRIME: 'parsec-prime-leave-team',
}

// Rental route
export const RENTAL_ROUTE = {
    OPERATING_SYSTEM_LIST_VIEW: 'operating-system-list-view',
    MASTER_LIST_VIEW: 'master-list-view',
    CHANGE_SERVICE_PACKAGE_LIST_VIEW: 'change-service-package-list-view',
    CHANGE_SERVICE_PACKAGE: 'change-service-package',
    SERVICE_PACKAGE_VIEW: 'service-package-view',
    MACHINE_LIST_VIEW: 'machine-list-view',
    RENTAL_REQUEST_CREATE: 'rental-request-create',
    CREATE_IMAGE: 'create-image',
    BOOT_MACHINE: 'boot-machine',
    REMOVE_IMAGE: 'remove-image',
    RENAME_IMAGE: 'rename-image',
    SHUTDOWN_MACHINE: 'shutdown-machine',
    SETTINGS_MACHINE: 'settings',
    CLONE_IMAGE: 'clone-image',
    DOWNLOAD_REMOTE_DESKTOP: 'download-remote-desktop',
    HARDWARE_FIXATION: 'hardware-fixation',
    SCHEDULER_MACHINE: 'scheduler-machine',
    RESTART_MACHINE: 'restart-machine',
    RESET_MACHINE: 'reset-machine',
    DISCONNECT_INTERNET_MACHINE: 'disconnect-internet-machine',
    ACTIVATE_SOFTWARE_LICENSE: 'turn-on-off-license',
    PROCESS_MONITORING_VIEW: 'process-monitoring-view',
    PROCESS_MONITORING_REMOVE: 'process-monitoring-remove',
    PROCESS_MONITORING_ENABLE: 'process-monitoring-enable',
}

// Fixed rental route
export const FIXED_RENTAL_ROUTE = {
    FIXED_RENTAL_VIEW: 'fixed-rental-view',
    FIXED_RENTAL_CREATE_IMAGE: 'fixed-rental-create-image',
    FIXED_RENTAL_CREATE: 'fixed-rental-create',
    FIXED_RENTAL_RENEWAL: 'fixed-rental-renewal',
    FIXED_RENTAL_RENEWAL_MACHINE: 'fixed-rental-renewal-machine',
    FIXED_RENTAL_DEACTIVATE: 'fixed-rental-deactivate',
    FIXED_RENTAL_SETTINGS: 'fixed-rental-settings',
}

// Extra service
export const EXTRA_SERVICE_ROUTE = {
    CREATE_REQUEST: 'create-request',
    CHECK_PORT: 'check-port',
    HISTORY_VIEW: 'history-view',
}

// Billing
export const BILLING_ROUTE = {
    BILLING_HISTORY_VIEW: 'billing-history-view',
}

// Transaction
export const TRANSACTION_ROUTE = {
    TRANSACTION_RECHARGE_HISTORY_VIEW: 'transaction-recharge-history-view',
    TRANSACTION_COUPON_HISTORY_VIEW: 'transaction-coupon-history-view',
    TRANSACTION_EXPORT_INVOICE: 'transaction-export-invoice',
    TRANSACTION_NO_RECEIPTS: 'transaction-no-receipts',
}

// Notifications
export const NOTIFICATIONS_ROUTE = {
    NOTIFICATIONS_VIEW: 'notifications-view',
    NOTIFICATIONS_REMOVES_STATUS: 'notifications-remove-status',
    NOTIFICATIONS_MARK_STATUS: 'notifications-mark-status',
    NOTIFICATIONS_MARK_ALL_READ: 'notifications-mark-all-read',
}

// Rating
export const RATING_ROUTE = {
    RATING_SUBMIT: 'rating-submit',
}

// Coupons
export const COUPONS_ROUTE = {
    COUPONS_VIEW: 'coupons-view',
}

// Coupons
export const USER_HISTORY_ROUTE = {
    ACTIVITY_LOG: 'activity-log',
}


// Snapshot
export const SNAPSHOT_ROUTE = {
    GET_SNAPSHOT_LIST: 'get-snapshot-list', //get-snapshot-list/{machineId}
    GET_SNAPSHOT_BY_ID: 'get-snapshot-by-id', //get-snapshot-by-id/{snapshotId}
    CHECK_CONDITIONAL_CREATE: 'conditional-snapshot-create', //conditional-snapshot-create/{machineId}
    CREATE_SNAPSHOT: 'create-snapshot',
    UPDATE_SNAPSHOT: 'update-snapshot',
    REMOVE_SNAPSHOT: 'remove-snapshot',
    REMOVE_SNAPSHOT_BY_MACHINE: 'remove-by-machine',
    RESTORE_SNAPSHOT: 'restore-snapshot'
}

// developer api
export const API_ROUTE = {
    ENABLE_API: 'enable-api',
    GET_API_INFO: 'get-api-infomations',
    ADD_RESTRICTIONS: 'add-restrictions',
    REMOVE_RESTRICTIONS: 'remove-restrictions'
}


// news api
export const NEWS_ROUTE = {
    GET_IMPORTANT_NEWS: 'get-important-news',
    GET_ACTIVE_NEWS: 'get-news-active',
}

// chat api
export const CHAT_HISTORY_ROUTE = {
    GET_CHAT_CONVERSATION: 'get-chat-conversation',
    GET_CHAT_HISTORY: 'get-chat-history',
    GET_CHAT_HISTORY_BY_CONVERSATION: 'get-chat-history-by-conversation',
}